import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-1 mb-3 text-headline-small" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "mb-2" }

import { ref, computed } from 'vue';
import i18n from '@/lang/i18n';
import VehicleTimedPosition from '@/types/VehicleTimedPosition';
import getVehicleResponse from '@/types/responses/getVehicle';
import Coordinates from '@/types/Coordinates';
import { getAddress } from '@/services/Geocoder';
import { vehiclePositionSourceType as sourceType } from '@/services/consts';


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoWindowContents',
  props: {
    vehiclePosition: {},
    vehicleInfo: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const isLoadingAddress = ref(false);
const vehicleAddress = ref<string>('');

const connectionStateIcon = computed(() => {
  const s = props.vehiclePosition?.source;
  if (s === sourceType.SUBSCRIBED) {
    return {
      name: "mdi-signal-variant",
      class: "text-light-green-accent-4"
    }
  }
  return {
    name: "mdi-rss-off",
    class: "text-red-accent-3"
  }
});

async function setVehicleAddress(coord: Coordinates) {
  isLoadingAddress.value = true;

  if (vehicleAddress.value) {
    vehicleAddress.value = '';
  }

  try {
    const address = await getAddress(coord);
    if (address === null) {
      return;
    }
    vehicleAddress.value = address;
  } catch (e) {
    console.error(e)
    vehicleAddress.value = i18n.global.t('pages.vehicleInstall.errors.getAddress')
  } finally {
    isLoadingAddress.value = false;
  }
}

function clearVehicleAddress() {
  vehicleAddress.value = '';
}

__expose({
  clearVehicleAddress
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h5", _hoisted_1, [
      _createVNode(_component_v_icon, {
        class: _normalizeClass(connectionStateIcon.value.class)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(connectionStateIcon.value.name), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createTextVNode(" " + _toDisplayString(props.vehicleInfo?.number_plate), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", null, _toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.map.infoWindow.dataTransmission.title')), 1),
      _createVNode(_component_v_card, {
        variant: "flat",
        class: "px-3 py-2 mb-2 bg-black text-light-green-accent-3 text-body-large"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.vehiclePosition?.time), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!vehicleAddress.value && props.vehiclePosition)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "flat",
            class: "bg-grey-lighten-3",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (setVehicleAddress(props.vehiclePosition?.position)), ["stop"])),
            loading: isLoadingAddress.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.vehicleInstall.map.infoWindow.getAddress')), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            variant: "flat",
            class: "bg-grey-lighten-3 px-4 py-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(vehicleAddress.value), 1)
            ]),
            _: 1
          }))
    ])
  ]))
}
}

})